const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		resourceRegisterKey: 'segments' // provides data of resourceRegister as this.resourceData
	},

	// keep elements in model because resources are changing (resource-register vs resource of component)
	model: {
		availableSegments: [],
		assignedMailingSegments: {},
		assignedMailingListID: 0,
		assignedMailingLists: {},
		mailingID: 0,
		statsRecipients: 0
	},

	events: {
		importForMailing: {
			type: 'click',
			selector: 'button.importForMailing',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				self.model.actionInEffect = 'importSubscribers';
				self.performAndStoreAction(
					'showChooseMailingList_inEffect',
					self.prepareAction('showChooseMailingList', undefined, {
						chooseMailingList: {
							preventMailingIDSelection: true,
							grantedMailingListIDs: self.model.assignedMailingLists.map(function(data){
								return ((data || {}).attributes || {}).mailingListID || 0;
							})
						}
					}, {
						source: {
							load: {
								componentData: {
									actions: {
										loadContent: {
											source: {
												load: {
													componentData: {
														model: {
															dirtyFields: {
																data: {
																	attributes: {
																		mailingID: self.model.mailingID
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					})
				)
			}
		},
		addSelectedMailingSegment: {
			type: 'click',
			selector: 'button.addSelectedSegment',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $segments = self.$.find('select[name="segments"]');
				if($segments.length > 0){
					var segmentID = $segments.val();
					if (segmentID !== '-') {
						var mailingListID = $segments.find('option[value="' + segmentID + '"]').closest('optgroup').data('mailingListId');
						if(mailingListID){
							self.addMailingSegment(segmentID, mailingListID);
						}
					}
				}
			}
		},

		removeMailingSegment: {
			type: 'click',
			selector: 'div.removeMailingSegment',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $segment = $(event.target).closest('.mailingSegment');
				if($segment.hasClass('importedForMailing')){
					self.removeMailingSubscribers();
				} else {
					var mailingSegmentID = $segment.data('mailingSegmentId');
					self.removeMailingSegment(mailingSegmentID);
				}
			}
		},

		showEdit_mailingSubscribers: {
			type: 'click',
			selector: 'div.showEdit_mailingSubscribers',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $segment = $(event.target).closest('.mailingSegment');
				if($segment.hasClass('importedForMailing')){
					self.showEdit_mailingSubscribers();
				}
			}
		},

		refreshSegmentCount: {
			type: 'click',
			selector: 'div.subscriptionCount i',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var segmentID = $(event.target).closest('.mailingSegment').data('segmentId');
				if (segmentID) self.refreshSegmentCount(segmentID, true);
			}
		},

		refreshAssignedRecipientsCount: {
			type: 'click',
			selector: 'div.assignedRecipientsCount i',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				self.$.find('.mailingSegment').each(function(index){
					var segmentID = $(this).data('segmentId');
					if(segmentID) self.refreshSegmentCount(segmentID, false, false);
				});
				self.refreshAssignedRecipientsCount();

				var statusController;
				if((statusController = getComponent('statusController'))) {
					statusController.addPanel('status.done.refresh');
				}
			}
		}
	},
	methods: {

		getResourceFilters: function(storage, resourceFilters, actionKey) {
			if(actionKey === 'refreshResources'){
				return {
					mailingID: this.model.mailingID
				};
			}

			return resourceFilters;
		},

		refreshSegmentCount: function(segmentID, updateAssignedRecipientCount, showPanel){
			var self = this;
			var $assignedMailingSegment = this.$.find('.mailingSegment[data-segment-id=' + segmentID + ']')
			self.performAction(
				self.prepareAction('refreshSegmentCount', segmentID)
			).then(function(context){
				var result = ((context.action.response || {}).data || {});
				var subscriberCount 		 			= result.subscriberCount * 1;
				var subscriberCountTimeStamp 			= result.subscriberCountTimeStamp;
				var $subscriptionCount 					= $assignedMailingSegment.find('div.subscriptionCount');
				if(subscriberCount > 0){
					$subscriptionCount.removeClass('no-recipients');
				} else {
					$subscriptionCount.addClass('no-recipients');
				}
				$subscriptionCount.find('span').text(subscriberCount || 'keine');
				$subscriptionCount.find('.lastSegmentUpdateTS').html('Letzte Aktualisierung am: ' + utils.moment(subscriberCountTimeStamp).format('LLLL'));
				// refresh list of mailings
				if (updateAssignedRecipientCount) {
					self.refreshAssignedRecipientsCount();
				}

				var statusController;
				if(showPanel !== false && (statusController = getComponent('statusController'))) {
					statusController.addPanel('status.done.refresh');
				}
			});
		},

		refreshAssignedRecipientsCount: function(){
			var self = this;
			self.performAction(
				self.prepareAction('refreshAssignedRecipientsCount', self.model.mailingID)
			).then(function(context){
				var result = ((context.action.response || {}).data || {});
				// set overall count
				self.$.find('.assignedRecipientsCount .count').text(result.subscriberCount > 0 ? result.subscriberCount : '-');
				// set import count
				var importRecipientSum = 0;
				var $mS = self.$.find('.mailingSegment.importedForMailing');
				var $mlNames = $mS.find('.mailinglistName');
				$mlNames.html('');
				if(utils.collectionSize(result.mailingImportDetails) > 0){
					$mS.removeClass('hidden');
					for (var i in result.mailingImportDetails) {
						var stat = result.mailingImportDetails[i];
						$mlNames.append(stat.mailingListName + '&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;' + stat.importedMailingSubscriberCount + '<br>');
						importRecipientSum += parseInt(stat.importedMailingSubscriberCount);
					}
				}
				self.$.find('.mailingSegment.importedForMailing .subscriptionCount span').text(importRecipientSum);
				// refresh mailings list and subscribers
				self.refreshExternalSegmentDependents();
			});
		},

		sanitizeResources: function(){
			// called with "availableSegments" from resourceRegister
			if (this.resourceData.availableSegments) {
				this.model.availableSegments = (this.resourceData.availableSegments || {}).data || [];
			}
			if (this.resourceData.assignedMailingLists) {
				this.model.assignedMailingLists = (this.resourceData.assignedMailingLists || {}).data || [];
			}
			if (this.resourceData.mailingID) {
				this.model.mailingID = this.resourceData.mailingID;
			}
			if (this.resourceData.statsRecipients) {
				this.model.statsRecipients = this.resourceData.statsRecipients;
			}

			// called with "data" from resource-definition of component to set "assignedMailingSegments"
			if (this.resourceData.data) {
				this.model.assignedMailingSegments = {};
				this.model.assignedMailingListID = 0;
				var s, segmentID;

				for (s in this.resourceData.data) {
					segmentID = this.resourceData.data[s].attributes.segmentID;
					if(segmentID){
						this.model.assignedMailingSegments[segmentID] = this.resourceData.data[s].attributes.mailingSegmentID;
						if(!this.model.assignedMailingListID && ((this.model.availableSegments || {})[segmentID] || {}).mailingListID){
							this.model.assignedMailingListID = this.model.availableSegments[segmentID].mailingListID;
						}
					}
				}
			}
		},

		addMailingSegment: function(segmentID, mailingListID){
			var self = this;

			if(segmentID){
				if(mailingListID && self.model.assignedMailingListID && self.model.assignedMailingListID !== mailingListID){
					return self.performAction(
						self.prepareAction('message', undefined, {
							messageDisplay: {
								message: 'error:newsletter.mailings.segments.insert.mailingListConflictInSegments'
							}
						})
					);
				} else {
					return self.performAction(
						self.prepareAction('add_mailingSegment', undefined, undefined, {
							source: {
								submit: {
									data: {
										data: {
											attributes: {
												segmentID : segmentID,
												mailingID : self.model.mailingID
											}
										}
									}
								}
							}
						})
					).then(function(context){
						self.refreshSegmentCount(segmentID, false, false);
						self.refreshExternalSegmentDependents();
						// refresh this segment assignment list
						self.refresh();
					});
				}
			}

			return utils.promise.reject();
		},

		refreshExternalSegmentDependents: function(){
			this.callHandler('refreshAfterMailingSegmentsChange');
		},

		removeMailingSegment: function(mailingSegmentID){
			var self = this;
			return self.performAction(
				self.prepareAction('delete_mailingSegment', mailingSegmentID)
			).then(function(context){
				// refresh list of mailings and subscribers
				self.refreshExternalSegmentDependents();
				// refresh this segment assignment list
				self.refresh();
			});
		},

		removeMailingSubscribers: function(){
			var self = this;

			if(self.model.mailingID){
				return self.performAction(
					self.prepareAction('delete_mailingSubscribers', undefined, undefined, {
						source: {
							submit: {
								resourceFilters: {
									mailingID: self.model.mailingID
								}
							}
						}
					})
				).then(function(context){
					// refresh list of mailings and subscribers
					self.refreshExternalSegmentDependents();
					// refresh this segment assignment list
					self.refresh();
				});
			}
		},

		showEdit_mailingSubscribers: function(){
			var self = this;

			if(self.model.mailingID){
				return self.performAndStoreAction(
					'showEdit_mailingSubscribers_inEffect',
					self.prepareAction('showEdit_mailingSubscribers', undefined, {
						subscriberSpecifics: {
							mailingID: self.model.mailingID,
						}
					}),
					true
				);
			}
		}
	},

	hooks: {
		attach: function($element, options) {
			this.refreshAssignedRecipientsCount();
		},

		async onDecision($element, options){
			var self = this;
			if(options.decisionComponent.hasClass('base_modal_modal')){
				if(options.decisionType === 'cancel'){
					await options.decisionComponent.hide()

					if (
						options.decisionComponent.hasClass('container_templates_newsletter_subscribers_importer') ||
						options.decisionComponent.hasClass('container_templates_newsletter_subscribers_controller')
					) {
						// refresh list of mailings and subscribers
						self.refreshExternalSegmentDependents()
						// refresh this segment assignment list
						self.refresh()
					}
				} else {
					var chooseMailingListForm;
					if (options.decisionTriggerComponent && options.decisionTriggerComponent.hasClass('templates_newsletter_subscribers_chooseMailingListForm')){
						chooseMailingListForm = options.decisionTriggerComponent;
					} else if (options.decisionComponent.hasClass('container_templates_newsletter_subscribers_chooseMailingListForm')) {
						options.decisionComponent.find('templates_newsletter_subscribers_chooseMailingListForm', function (chooseMailingListFormComponent) {
							chooseMailingListForm = chooseMailingListFormComponent;
						});
					}

					if (chooseMailingListForm) {
						var mailingListData = String((((chooseMailingListForm.model.dirtyFields || {}).data || {}).attributes || {}).mailingListAndComponentID || '').split('_');
						if(mailingListData.length > 1){

							var mailingID = ((((chooseMailingListForm.model.dirtyFields || {}).data || {}).attributes || {}).mailingID || 0);

							mailingListData = {
								mailingListID: 				mailingListData[0],
								additionalDataComponentID: 	mailingListData[1],
								mailingID:					mailingID
							};

							await options.decisionComponent.hide();

							if(self.model.actionInEffect === 'importSubscribers'){
								return self.performAction(
									self.prepareAction('show_subscriberImporter', undefined, {
										subscriberImporterUploader: {
											mailingListID:	(mailingListData || {}).mailingListID,
											mailingID:		mailingID
										}
									})
								);
							}
						} else {
							await this.performAction(
								this.prepareAction('message', undefined, {
									messageDisplay: {
										message: 'error:newsletter.subscriber.insert.missingMailingList'
									}
								})
							);
						}
					} else if (
						options.decisionComponent.hasClass('container_templates_newsletter_subscribers_importer') ||
						options.decisionComponent.hasClass('container_templates_newsletter_subscribers_controller')
					) {
						await options.decisionComponent.hide();

						// refresh list of mailings and subscribers
						self.refreshExternalSegmentDependents();
						// refresh this segment assignment list
						self.refresh();
					}
				}
			}
		},

		onSegmentsUpdate: function($element, options){
			var self = this;
			this.furthest('base_tabStrip_tabStrip', undefined, function(tabStrip){
				tabStrip.find('templates_newsletter_mailings_mailings', function(mailings) {
					if (mailings.model.mailingRegisterLookUp[self.model.mailingID]){
						self.model.availableSegments = mailings.model.mailingRegisterLookUp[self.model.mailingID].segments.availableSegments;
						self.refresh(false);
					}
				});
			});
		},

		closeTabByMailingID: function($element, options){
			var self = this;
			if((options || {}).mailingID === self.model.mailingID){
				self.furthest('base_tabStrip_tabContent', undefined, function(tabContent){
					if(tabContent.config.registerSecret){
						tabContent.closest('base_tabStrip_tabStrip', function(tabStrip){
							var activeRegisterSecret = tabStrip.model.activeRegisterSecret;
							tabStrip.removeTab(tabContent.config.registerSecret);
							tabStrip.focusTab(activeRegisterSecret);
						});
					}
				});
			}
		}
	}
}